import React from 'react';
import { useLogFeatureAction } from 'hooks/api/feedback/useLogFeatureAction';
import { useGetDisplayFeedbackDialog } from 'hooks/api/feedback/useGetDisplayFeedbackDialog';
import SessionNoteClass from './SessionNoteClass';

const SessionNotesWrapper = (props) => {
  const { logAction } = useLogFeatureAction();
  const { shouldDisplayDialog, triggerGateCheck } = useGetDisplayFeedbackDialog();

  return (
    <SessionNoteClass
      {...props}
      logAIFeatureAction={logAction}
      getDisplayFeedbackDialog={triggerGateCheck}
      shouldDisplayFeedbackDialog={shouldDisplayDialog}
    />
  );
};

export default SessionNotesWrapper;